import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Center, Loader, Text } from '@mantine/core';
import { isAdmin } from '../../utils/authUtils';

/**
 * admin ロールを持つユーザーのみ通過できるルートガード
 * 権限がない場合は /Study にリダイレクトする
 */
function AdminRoute({ user, children }) {
  const [checking, setChecking] = useState(true);
  const [adminVerified, setAdminVerified] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      if (!user) {
        setAdminVerified(false);
        setChecking(false);
        return;
      }

      const result = await isAdmin(user);
      setAdminVerified(result);
      setChecking(false);
    };

    checkAdmin();
  }, [user]);

  // ロール確認中はローディング表示
  if (checking) {
    return (
      <Center h={200}>
        <Loader size="sm" />
        <Text ml="xs" c="dimmed">権限を確認中...</Text>
      </Center>
    );
  }

  // admin でなければ Study ページにリダイレクト
  if (!adminVerified) {
    return <Navigate to="/Study" replace />;
  }

  return children;
}

export default AdminRoute;
